import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

declare global {
  interface Window {
    Office: typeof Office;
  }
}

function renderError(msg: string): void {
  const root = document.getElementById("root");
  if (!root) return;
  root.innerHTML = `<div style="padding:1.5rem;font-family:system-ui">
    <h1 style="font-size:1.1rem;margin:0 0 0.5rem">Diff & Export PDF</h1>
    <p style="color:#78716c">${msg}</p>
  </div>`;
}

Office.onReady((info) => {
  if (info.host !== Office.HostType.Excel) {
    renderError("Cet add-in ne fonctionne que dans Excel.");
    return;
  }
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
